import React from 'react';
import { ButtonProps } from 'react-toolbox/lib/button/Button';
import less from './progressbar.less';

export type statusTypes = 'error' | 'success' | 'busy';

export interface ProgressBarProps extends ButtonProps {
   status?: statusTypes;
   extraClassNames?: string[];
   caption: string;
   onExtraFunction?: () => any;
}

// tslint:disable-next-line:max-classes-per-file
export class ProgressBar extends React.Component<any, ProgressBarProps, any> { 
  className = this.props.className;
  caption = this.props.caption;
  type = this.props.type;
  disabled = this.props.disabled;
  extraClassNames= this.props.extraClassNames ? this.props.extraClassNames:[];
  arialabel = this.props['aria-label'];                       
  tabIndex = this.props.tabIndex;  
  allClassNames: string[] = [];
  status: statusTypes = this.props.status;

  public render() { 
    this.allClassNames= [this.className];
    if (this.extraClassNames) 
      this.allClassNames=this.allClassNames.concat(this.extraClassNames);

    return (
        <div className={less('backdrop')} 
                style={{ opacity: 1 }} 
                aria-label={this.arialabel}>
            <div className={less('showbox')}>
                <div className={less('loadercaption')}>{this.caption}</div>
                    {
                      this.status === 'busy'?
                      <div className={less('loader')}>
                        <svg className={less('circular')} viewBox="25 25 50 50">
                              {<circle className={less('path')} cx="50" cy="50" r="20" fill="none"/> }
                              {this.props.children}                          
                        </svg>
                      </div>
                      :
                      <div className={less('status-div')}>
                        <span className={this.status === 'error'? less('error'):
                                     this.status === 'success'? less('success') :'' }> </span>
                      </div>                        
                    }
            </div>
        </div>
    );
  
  }
}



// WEBPACK FOOTER //
// (webpack)-remove-block-loader??ref--5-0!./src/react-toolbox-redesign/progressbar.tsx